import React from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import Page from "containers/Page/Page";
import { Tabs, Tab, Tooltip, Typography, Divider } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

const SigilTabPage = ({ tabs, title, subtitle, Actions, actionOptions }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const pieces = pathname.split("/");
  const tabValue = pieces[pieces.length - 1];
  const noSpaceOpts = tabs.map((opt) => opt.tabTitle.replace(/\s+/g, ""));
  const selectedTab = noSpaceOpts.indexOf(tabValue);

  const handleChange = (event, newValue) => {
    navigate(tabs[newValue].tabTitle.replace(/\s+/g, ""));
  };

  return (
    <Page title={title}>
      <Box sx={{ flexGrow: 1 }}>
        <Typography sx={{ mt: 1, mb: 1 }}>{subtitle}</Typography>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            sx={{
              mb: 3,
            }}
          >
            {tabs.map((tab) => (
              <Tooltip
                key={tab.tabTitle}
                title={tab.tooltip}
                placement="bottom"
              >
                <Tab key={tab.tabTitle} label={tab.tabTitle}></Tab>
              </Tooltip>
            ))}
          </Tabs>
          {Actions && (
            <Actions
              name="exportData"
              options={{ ...actionOptions }}
              sx={{ position: "relative", top: "-14px" }}
            />
          )}
        </Stack>
      </Box>

      {/* 177 being the magic number for the height of the header and tab bar. */}
      <Box
        sx={{
          display: "flex",
          height: `calc(100vh - 177px)`,
        }}
      >
        <Outlet />
      </Box>
    </Page>
  );
};

export default SigilTabPage;
